module.exports = __webpack_public_path__ + "static/media/zoo.a75c6bad.svg";